<template>
  <div class="jms-table-wrap">
    <!-- 表格头部 -->
    <div id="jmsMenu" class="jms-table-menu" v-if="tableOption.tableHeader">
      <slot name="tableHeader"></slot>
    </div>
    <!-- 表格 -->
    <el-table ref="table"
        v-loading="tableLoading"
        v-if="rerenderTable"
        :data="list"
        :row-key="handleGetRowKeys"
        :border="tableOption.border || true"
        :expand-row-keys="tableOption.expandRowKeys"
        :default-expand-all="tableOption.defaultExpandAll"
        :stripe="tableOption.stripe || true"
        :selectable="tableOption.selectable"
        :show-header="tableOption.showHeader"
        :default-sort="tableOption.defaultSort"
        :row-class-name="rowClassName"
        :cell-class-name="cellClassName"
        :header-cell-class-name="headerCellClassName"
        :max-height="tableOption.maxHeight"
        :width="tableOption.width"
        :height="tableOption.tableHeight || tableHeight - (tableOption.fixHeight || 0)"
        :highlight-current-row="tableOption.currentRow || false"
        @current-change="currentRowChange"
        @expand-change="expandChange"
        @row-click="rowClick"
        @row-dblclick="rowDblclick"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
        @selection-change="selectionChange"
        @select="select"
        @select-all="selectAll"
        @sort-change="sortChange"
        >
        <!-- 暂无数据提醒 -->
        <template slot="empty">
          <div class="avue-crud__empty">
            <slot name="empty" v-if="$slots.empty"></slot>
            <empty v-else size="50" :desc="tableOption.emptyText || $lang('暂无数据')"></empty>
          </div>
        </template>
        <!-- 折叠面板  -->
        <el-table-column type="expand"
                        width="60"
                        align="center"
                        v-if="tableOption.expand">
          <template slot-scope="props">
            <slot :row="props.row"
                  name="expand"></slot>
          </template>
        </el-table-column>
        <!-- 选择框 -->
        <el-table-column v-if="tableOption.selection"
                        type="selection"
                        :selectable="tableOption.selectable"
                        :reserve-selection="tableOption.reserveSelection"
                        width="50"
                        align="center"></el-table-column>
        <!-- 序号 -->
        <el-table-column v-if="tableOption.index!==undefined ? tableOption.index : true"
                        :label="$lang(tableOption.indexLabel!==undefined ? tableOption.indexLabel : '序号')"
                        type="index"
                        width="100"
                        :index="indexMethod"
                        fixed="left"
                        align="center"></el-table-column>
        <!-- 占位符号解决ele问题 -->
        <!-- <el-table-column width="0px" v-show="false"></el-table-column> -->
        <column :columnOption="columnOption">
          <template v-for="(item) in propOption" slot-scope="scope" :slot="item.prop">
            <slot :row="scope.row"
                  v-if="item.show!==false"
                  :dic="scope.dic"
                  :size="scope.size"
                  :label="scope.label"
                  :name="item.prop"></slot>
          </template>
        </column>
        <!-- 操作列 -->
        <el-table-column fixed="right"
                        v-if="tableOption.menu!==undefined ? tableOption.menu : true"
                        :label="$lang('操作')"
                        :align="tableOption.menuAlign"
                        :header-align="tableOption.menuheaderAlign"
                        :width="tableOption.menuWidth || 90">
          <template slot-scope="scope">
            <el-dropdown v-if="menuType === 'menu'" style="margin-right:9px;">
              <el-button type="primary">
                {{$lang('更 多')}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="tableOption.viewBtn"
                                  @click.native="rowView(scope.row,scope.$index)">{{$lang('查 看')}}</el-dropdown-item>
                <el-dropdown-item divided
                                  v-if="tableOption.editBtn"
                                  @click.native="rowEdit(scope.row,scope.$index)"> {{$lang('编 辑')}}</el-dropdown-item>
                <el-dropdown-item divided
                                  v-if="tableOption.delBtn"
                                  @click.native="rowDel(scope.row,scope.$index)">{{$lang('删 除')}}</el-dropdown-item>
                <slot name="menuBtn"
                      :row="scope.row"
                      :dic="scope.dic"
                      :label="scope.label"
                      :index="scope.$index"></slot>
              </el-dropdown-menu>
            </el-dropdown>
            <template v-else-if="['button','text','icon'].includes(menuType)">
              <!-- 查看按钮 -->
              <el-button :type="menuType"
                        icon="iconfont iconchakan"
                        @click.stop="rowView(scope.row,scope.$index)"
                        :disabled="tableOption.viewDisabled"
                        title="查看"
                        v-if="tableOption.viewBtn !== false && scope.row.$view !== false"></el-button>
              <!-- 编辑按钮 -->
              <el-button :type="menuType"
                        icon="iconfont iconbianji font-16"
                        :disabled="tableOption.editDisabled"
                        @click.stop="rowEdit(scope.row,scope.$index)"
                        title="编辑"
                        v-if="tableOption.editBtn !== false && scope.row.$edit !== false"></el-button>
              <!-- 删除按钮 -->
              <el-button :type="menuType"
                        icon="iconfont iconshanchu font-16"
                        :disabled="tableOption.deleteDisabled"
                        @click.stop="rowDel(scope.row,scope.$index)"
                        title="删除"
                        v-if="tableOption.delBtn !== false && scope.row.$delete !== false"></el-button>
            </template>
            <slot name="menu"
                  :row="scope.row"
                  :type="menuType"
                  :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                  label=""
                  v-if="tableOption.dynamicOptions!==undefined ? true : false"
                  class-name="dynamicact-col"
                  width="24">
        </el-table-column>
      </el-table>
      <!-- 动态列 -->
      <!-- <DragColumn ref="dynamicColumn" :dynamicColumns="dynamicColumns" v-if="tableOption.dynamicColumn"></DragColumn> -->
      <!-- 分页 -->
      <JmsTablePage v-show="tablePageVisible" class="avue-crud__pagination" ref="tablePage" id="jmsPagination"></JmsTablePage>
  </div>
</template>
<script>
import empty from './empty'
import column from './column'
// import DragColumn from './drag-column'
import JmsTablePage from './table-page'
import { RESPONSE_SUCCESS } from '@constants'
import { deepClone } from '../util/util'
import fetch from '@http/request'
import { mapGetters } from 'vuex'
import qs from 'qs'

export default {
  name: 'JmsTable',
  components: {
    empty,
    JmsTablePage,
    column,
    // DragColumn,
  },
  provide () {
    return {
      crud: this,
    }
  },
  data () {
    return {
      DIC: {}, // 字典集合
      tableOption: {},
      permission: {},
      list: [],
      dynamicColumns: [],
      rerenderTable: true,
    }
  },
  watch: { // 监听配置项的变化 并重新初始化
    option: {
      handler() {
        this.init()
      },
      deep: true,
    },
    data () {
      this.dataInit()
    },
    page: {
      handler () {
        this.$refs.tablePage.pageInit()
      },
      deep: true,
    },
  },
  props: {
    option: { // 列表配置项
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
    rowClassName: Function,
    cellClassName: Function,
    headerCellClassName: Function,
    page: {
      type: Object,
      default () {
        return {}
      },
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
    tablePageVisible: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
  },
  computed: {
    ...mapGetters({
      lang: 'lang',
      tableHeight: 'tableHeight',
    }),
    propOption () {
      const result = []
      const safe = this
      function findProp (list) {
        list.forEach(ele => {
          if (ele.prop) {
            result.push(ele)
          }
          if (ele.children) {
            safe.isChild = true
            findProp(ele.children)
          }
        })
      }
      findProp(this.columnOption)
      return result
    },
    columnOption () {
      return this.tableOption.column || []
    },
    menuType() {
      return this.tableOption.menuType || 'text'
    },
  },
  created() {
    this.init()
    // 初始化数据
    this.dataInit()
  },
  methods: {
    // 查看
    rowView (row, index) {
      this.$emit('row-view', row, index)
    },
    // 删除
    rowDel(row, index) {
      this.$emit('row-del', row, index)
    },
    // 编辑
    rowEdit (row, index) {
      this.$emit('row-edit', row, index)
    },
    // 检测本地字典
    initDic() {
      // 表格赋值
      this.propOption.forEach(ele => {
        if (Array.isArray(ele.dicData)) {
          this.$set(this.DIC, ele.prop, ele.dicData)
        }
      })
    },
    dataInit () {
      this.list = [...this.data]
      // 初始化序列的参数
      this.list.forEach((ele, index) => {
        ele.$index = index
        /*
       *存在操作按钮根据业务状态显示隐藏操作按钮 初始化显隐参数 避免在template中使用函数处理 以提高组件性能
       *@Description: tableOption.btnsVisible()
       *@param {ele} type Object
       *@return [type] Object 例如 { view: false, edit:false }
       *@Date: 2019-08-01 10:59:27
      */
        if (typeof this.tableOption.btnsVisible === 'function') {
          this.list.forEach((ele, index) => {
            const btnVisible = this.tableOption.btnsVisible(ele) || {}
            ele.$view = btnVisible.view
            ele.$edit = btnVisible.edit
            ele.$delete = btnVisible.delete
          })
        }
      })
    },
    rowDefaultClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return ''
      } else {
        return 'row2n-class'
      }
    },
    // 获取table row key
    handleGetRowKeys (row) {
      const rowKey = row[this.tableOption.rowKey || 'id']
      return rowKey
    },
    // 取消表格选择
    selectClear () {
      this.$refs.table.clearSelection()
    },
    getIsMobile() {
      this.isMobile = window.document.body.clientWidth <= 768
    },
    // 获取动态列
    fetchColumnData(tableOption) {
      return new Promise((resolve, reject) => {
        const reqUrl = tableOption.dynamicOptions.getUrl
        fetch.get(`${reqUrl}?` + qs.stringify(tableOption.dynamicOptions.params)).then(res => {
          if (res.code === RESPONSE_SUCCESS) {
            resolve(res.data)
          } else {
            reject(res)
            this.$message({ type: 'error', message: res.msg })
          }
        })
      })
    },
    // 设置动态列
    setCustomColumn(params) {
      const reqUrl = this.tableOption.dynamicOptions.saveUrl
      const baseobj = Object.assign({}, this.tableOption.dynamicOptions.params, params)
      fetch.post(`${reqUrl}`, baseobj).then(res => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success(res.msg)
          this.initDynamicColumn()
        } else {
          this.$message({ type: 'error', message: res.msg })
        }
      })
    },
    // 初始化表格
    init() {
      if (this.option.dynamicOptions) {
        this.initDynamicColumn()
      } else {
        this.tableOption = this.option || {}
      }
      // 初始化字典
      this.initDic()
    },
    initDynamicColumn() {
      const tableOption = deepClone(this.option)
      // const tableOption = this.option
      const column = tableOption.column
      const columnObj = {}
      const columnArr = []
      column.forEach((item) => {
        columnObj[item.prop] = item
      })
      this.rerenderTable = false
      this.fetchColumnData(tableOption).then(res => {
        if (res.length) {
          res.forEach((item) => {
            item.prop = item.name
            item.label = item.column
          })
          // eslint-disable-next-line
          // const filterobj = Object.keys(res).filter(key => (res[key].show === true)).reduce((newres, key) => (newres[key] = res[key], newres), {})
          const filterArr = res.filter((item) => item.show === true)

          filterArr.forEach((item) => {
            const itemkey = item.name
            // filterobj[item.name] = item
            if (columnObj[itemkey] !== undefined) {
              columnArr.push(Object.assign({}, item, columnObj[itemkey]))
            } else {
              columnArr.push({
                prop: itemkey,
                label: item.column,
              })
            }
          })
          tableOption.column = columnArr
          this.tableOption = deepClone(tableOption)
          this.dynamicColumns = res
          this.rerenderTable = true
        }
      })
    },
    indexMethod (index) {
      return (
        index +
        1 +
        ((this.$refs.tablePage.defaultPage.currentPage || 1) - 1) *
        (this.$refs.tablePage.defaultPage.pageSize || 10)
      )
    },
    // 展开或则关闭
    expandChange (row, expand) {
      this.expandList = [...expand]
      this.$emit('expand-change', row, expand)
    },
    // 设置单选
    currentRowChange (val) {
      this.$emit('current-row-change', val)
    },
    // 刷新事件
    refreshChange () {
      this.$emit('refresh-change', {
        page: this.defaultPage,
        searchForm: this.searchForm,
      })
    },
    // 选中实例
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.table.toggleRowSelection(row)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },
    // 选择回调
    selectionChange (val) {
      this.tableSelect = val
      this.$emit('selection-change', this.tableSelect)
    },
    // 单个选择回调
    select (selection, row) {
      this.$emit('select', selection, row)
    },
    // 点击勾选全选 Checkbox
    selectAll (selection) {
      this.$emit('select-all', selection)
    },
    // 排序回调
    sortChange (val) {
      this.$emit('sort-change', val)
    },
    // 行双击
    rowDblclick (row, event) {
      this.$emit('row-dblclick', row, event)
    },
    // 行单机
    rowClick (row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    // 当单元格 hover 进入时会触发该事件
    cellMouseEnter (row, column, cell, event) {
      this.$emit('cell-mouse-enter', row, column, cell, event)
    },
    // 当单元格 hover 退出时会触发该事件
    cellMouseLeave (row, column, cell, event) {
      this.$emit('cell-mouse-leave', row, column, cell, event)
    },
    // 当某个单元格被点击时会触发该事件
    cellClick (row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    // 当某个单元格被双击击时会触发该事件
    cellDblclick (row, column, cell, event) {
      this.$emit('cell-dblclick', row, column, cell, event)
    },
    // 滚动加载
    tableInfiniteScroll() {
      console.log(444)
      this.$emit('table-infinite-scroll')
    },
  },
}
</script>
<style>
.jms-table-wrap .el-table th {
    word-break: break-word;
    color: rgba(0, 0, 0, 0.85);
    background-color: #eeeeee;
}
.el-table th.dynamicact-col>.cell{padding: 0}
.jms-table-wrap .el-table th{
  background: #fff;
}
.el-table__empty-block{
  height: 100%;
}
</style>
